import { IUserCategoryBase } from '../../models/userCategories';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdateUserCategoriesProps {
  categoryId: string;
  orgIndexCode: string | null;
  maxDayBookings?: number;
  maxFreeGuestDayBookings?: number;
  maxGuestDayBookings?: number;
  title: string;
}

export type IUpdatedUserCategory = IUserCategoryBase;

export const updateUserCategoriesService = async ({
  orgIndexCode,
  categoryId,
  maxDayBookings,
  maxFreeGuestDayBookings,
  maxGuestDayBookings,
  title,
}: IUpdateUserCategoriesProps): Promise<IUpdatedUserCategory> => {
  const { data } = await jhsfBookingsApi.put<IUpdatedUserCategory>(
    `/user-categories/${categoryId}`,
    {
      maxDayBookings,
      maxFreeGuestDayBookings,
      maxGuestDayBookings,
      orgIndexCode,
      title,
    },
  );

  return data;
};
